import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherIcon from "./WeatherIcon";
import WeatherTemp from "./WeatherTemp";

export default function WeatherInfo(props) {
  return (
    <div className="WeatherInformation">
      <div className="row">
        <div className="col-2 text-end weather-icon float-left">
          <WeatherIcon code={props.data.icon} size={60} />
        </div>
        <div className="col-2 text-start p-0">
          <WeatherTemp celsiusData={props.data.temp} />
        </div>
        <div className="col-4">
          <small>
            <ul className="temp-data">
              <li>Humidity: {Math.round(props.data.humidity)}%</li>
              <li>Wind: {Math.round(props.data.wind)} km/h</li>
              <li>
                Max/Min: {Math.round(props.data.maxtemp)}° /{" "}
                {Math.round(props.data.mintemp)}°
              </li>
            </ul>
          </small>
        </div>
        <div className="col-4 text-end">
          <h2>{props.data.city}</h2>
          <ul className="local-data">
            <li>
              <FormattedDate date={props.data.date} />
            </li>
            <li className="text-capitalize">{props.data.description}</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
